import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

class TabsOne extends Component {
  render() {
    let tab3 = "Executives Master",
      tab4 = "Mooc";
    const { tabStyle } = this.props;

    return (
      <div>
        <div className="tabs-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Tabs>
                  <TabList
                    style={{ flexWrap: "inherit" }}
                    className={`${tabStyle}`}
                  >
                    <Tab className="w-100 text-center">{tab3}</Tab>
                    <Tab className="w-100 text-center">{tab4}</Tab>
                  </TabList>

                  <TabPanel>
                    <div className="single-tab-content">
                        <div className="thumbnail">
                          <img
                            className="w-100"
                            src="/assets/images/programs/master1.png"
                            alt="Master Images"
                            style={ { width: "70vw", margin: "30px auto", display: "block" }}
                          />
                        </div>
                      <div className="mt--50 mt_lg--10 mt_md--10 mt_sm--10">
                        <h5 className="text-bold">
                          Présentation du programme :
                        </h5>
                        <p>
                          Le Master Exécutif spécialisé dans les stratégies des
                          Smart cities en Afrique est un programme académique
                          d'une durée d'un an. Ce programme est spécifiquement
                          conçu pour les professionnels en activité et les
                          individus souhaitant développer des compétences
                          avancées dans le domaine de la gestion urbaine. Il est
                          proposé par le Centre des Systèmes Urbains (CUS) de
                          l'Université Mohammed VI Polytechnique de Benguerir
                          (UM6P), une institution renommée pour son excellence
                          académique et son expertise dans le domaine des Smart
                          cities.
                        </p>
                        <h5>Objectifs du programme :</h5>
                        <ul>
                          <li>
                            Former des professionnels capables de concevoir,
                            mettre en œuvre et évaluer des stratégies de
                            développement urbain intelligentes en Afrique.
                          </li>
                          <li>
                            Développer les compétences nécessaires pour intégrer
                            les technologies de l'information et de la
                            communication (TIC) dans la gestion des
                            infrastructures urbaines.
                          </li>
                          <li>
                            Favoriser l'adoption de pratiques durables et
                            résilientes dans la planification et la gestion
                            urbaine.
                          </li>
                          <li>
                            Encourager la collaboration entre les différents
                            acteurs du secteur urbain en Afrique pour une
                            approche holistique du développement des villes
                            intelligentes.
                          </li>
                        </ul>
                        <p>
                          <span
                            className="font-weight-bold"
                            style={{ color: "#000" }}
                          >
                            {" "}
                            En savoir plus :
                          </span>{" "}
                          <a
                            href="https://exed.um6p.ma/program/master-executif-en-strategies-des-smart-cities-en-afrique/ "
                            target="_blank"
                          >
                            https://exed.um6p.ma/program/master-executif-en-strategies-des-smart-cities-en-afrique/ {" "}
                          </a>
                        </p>
                      </div>
                    </div>
                  </TabPanel>

                  <TabPanel>
                    <div className="single-tab-content">
                      <div className="mt--30 mt_lg--10 mt_md--10 mt_sm--10">
                        <h4>
                          MOOCs : La gestion des données urbaines : clé du
                          développement de villes plus intelligentes
                        </h4>
                        <p>
                          Le MOOC explore divers concepts, théories et pratiques
                          liés à l’acquisition et la gestion des données
                          urbaines et met à la disposition des intervenants des
                          connaissances et compétences pratiques qui leurs
                          permetent de gérer et analyser les données urbaines de
                          manière efficace.
                        </p>
                        <p>
                          De façon plus spécifique, le cours introduit la notion
                          de données urbaines (massives) et propose des méthodes
                          à moindre coût pour les acquérir dans le contexte
                          africain via le Crowdsourcing. Le MOOC couvre
                          également les dernières technologies, méthodes et
                          outils nécessaires pour la gestion et la visualisation
                          des données urbaines, tels que les systèmes
                          d'information géographique (SIG) et la télédétection.
                        </p>
                        <p>
                          Enfin, cette formation permet de s’initier à
                          l’utilisation de l’intelligence artificielle pour la
                          modélisation dans le but de développer des supports de
                          décision dans la planification, la conception et la
                          gestion urbaines. Des études de cas permettent de
                          mieux comprendre les applications de ces méthodes dans
                          le développement de villes intelligentes en Afrique.
                        </p>
                        <p>
                          <span
                            className="font-weight-bold"
                            style={{ color: "#000" }}
                          >
                            Pour s’inscrire au MOOC :{" "}
                          </span>{" "}
                          <a
                            href="https://courses.africancitieslab.org/courses/course-v1:UM6P+003+2022/about "
                            target="_blank"
                          >
                            https://courses.africancitieslab.org/courses/course-v1:UM6P+003+2022/about{" "}
                          </a>
                        </p>
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default TabsOne;
